import { render, staticRenderFns } from "./chkStudentInfo.vue?vue&type=template&id=64b1c354&"
import script from "./chkStudentInfo.vue?vue&type=script&lang=js&"
export * from "./chkStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports